"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
        onCreate: function() {
          this.state = {
              expand: uiStore.get("admin-footer")
            };

          GState.bind(this, [
              "activities"
            ]);
        },
        onExpand: function(status) {
          this.state.expand = status;

          status ? uiStore.set("admin-footer", status) : uiStore.clear("admin-footer");
        }
      },
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/Footer-Admin.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    index_template = require("/workspace/src/views/components/Wrapper/index.marko"),
    Locale_template = require("../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    WSAdapt_template = require("../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    Row_template = require("../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    Bx_template = require("../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    route_link_template = require("marko-router5/src/components/route-link/index.marko"),
    route_link_tag = marko_loadTag(route_link_template),
    get_context_template = require("@marko-tags/context/src/components/get-context/index.marko"),
    get_context_tag = marko_loadTag(get_context_template),
    marko_attrs0 = {
        "class": "position-absolute w-100 left-0 bottom-0 px-md-4 px-2 theme-bg-fade zindex-4"
      },
    marko_attrs1 = {
        "class": "position-absolute cursor-pointer text-muted top-0 right-0 font-small-3 p-1"
      },
    marko_attrs2 = {
        href: "",
        "class": "card d-block theme-bg p-1",
        target: "_blank"
      },
    marko_attrs3 = {
        "class": "card-content"
      },
    marko_attrs4 = {
        "class": "card-body p-0"
      },
    marko_attrs5 = {
        "class": "font-small-3 text-ellipsis-2"
      },
    marko_attrs6 = {
        "class": "col"
      },
    marko_attrs7 = {
        "class": "font-medium-2 mt-0"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("8689dc"),
    marko_node0 = marko_createElement("img", {
        src: "/images/icons/user_account.png",
        "class": "w-75"
      }, "12", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs8 = {
        "class": "card d-block theme-bg p-1",
        target: "_blank"
      },
    marko_attrs9 = {
        "class": "card-content"
      },
    marko_attrs10 = {
        "class": "card-body p-0"
      },
    marko_attrs11 = {
        "class": "font-small-3 text-ellipsis-2"
      },
    marko_attrs12 = {
        "class": "col"
      },
    marko_attrs13 = {
        "class": "font-medium-2 mt-0"
      },
    marko_node1 = marko_createElement("img", {
        src: "/images/icons/comments.png",
        "class": "w-75"
      }, "24", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs14 = {
        href: "",
        "class": "card d-block theme-bg p-1",
        target: "_blank"
      },
    marko_attrs15 = {
        "class": "card-content"
      },
    marko_attrs16 = {
        "class": "card-body p-0"
      },
    marko_attrs17 = {
        "class": "font-small-3 text-ellipsis-2"
      },
    marko_attrs18 = {
        "class": "col"
      },
    marko_attrs19 = {
        "class": "font-medium-2 mt-0"
      },
    marko_node2 = marko_createElement("img", {
        src: "/images/icons/groups.png",
        "class": "w-75"
      }, "36", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs20 = {
        "class": "mb-4 font-medium-4"
      },
    marko_attrs21 = {
        "class": "font-small-3"
      },
    marko_attrs22 = {
        "class": "col-md-5 col-12 text-right",
        style: "padding-top:8px;padding-bottom:8px"
      },
    marko_attrs23 = {
        "class": "list-inline d-inline-flex align-items-center m-0"
      },
    marko_attrs24 = {
        "class": "d-inline-flex align-items-center cursor-pointer text-muted font-small-3",
        style: "padding-left:20px"
      },
    marko_attrs25 = {
        "class": "d-inline-flex align-items-center cursor-pointer text-muted font-small-3",
        style: "padding-left:20px"
      },
    marko_attrs26 = {
        "class": "cursor-pointer text-muted",
        style: "padding-left:20px"
      };

function render(input, out, __component, component, state) {
  var data = input;

  get_context_tag({
      __from: index_template,
      renderBody: function(out, { page }, emit) {
        out.be("div", marko_attrs0, "0", component);

        if (state.expand) {
          Row_tag({
              class: "m-0 d-flex align-items-center",
              col: [
                  {
                      ns: "col-lg-6 col-12",
                      qs: "col-lg-8 col-12",
                      hs: "col-lg-7 col-12",
                      renderBody: function(out) {
                        Row_tag({
                            class: "py-50",
                            col: [
                                {
                                    ns: "col-md-4 col-12",
                                    qs: "col-md-4 col-12",
                                    hs: "col-md-6 col-12",
                                    class: "px-50",
                                    renderBody: function(out) {
                                      out.be("a", marko_attrs2, "5", component);

                                      out.be("div", marko_attrs3, "6", component);

                                      Row_tag({
                                          class: "card-header p-0",
                                          renderBody: function(out) {
                                            out.be("div", marko_attrs6, "8", component);

                                            out.be("h5", marko_attrs7, "9", component);

                                            Locale_tag({
                                                renderBody: function(out) {
                                                  out.t("Privacy & Policy Guidlines");
                                                }
                                              }, out, __component, "10");

                                            out.ee();

                                            out.ee();

                                            WSAdapt_tag({
                                                hs: "col-4",
                                                class: "col-4 text-right",
                                                renderBody: function(out) {
                                                  out.n(marko_node0, component);
                                                }
                                              }, out, __component, "11");
                                          }
                                        }, out, __component, "7");

                                      out.ee();

                                      out.be("div", marko_attrs4, "13", component);

                                      out.be("p", marko_attrs5, "14", component);

                                      Locale_tag({
                                          renderBody: function(out) {
                                            out.t("We observe carefully all stand...");
                                          }
                                        }, out, __component, "15");

                                      out.ee();

                                      out.ee();

                                      out.ee();
                                    }
                                  },
                                {
                                    ns: "col-md-4 col-12",
                                    qs: "col-md-4 col-12",
                                    hs: "col-md-6 col-12",
                                    class: "px-50",
                                    renderBody: function(out) {
                                      out.be("a", marko_attrs8, "17", component);

                                      out.be("div", marko_attrs9, "18", component);

                                      Row_tag({
                                          class: "card-header p-0",
                                          renderBody: function(out) {
                                            out.be("div", marko_attrs12, "20", component);

                                            out.be("h5", marko_attrs13, "21", component);

                                            Locale_tag({
                                                renderBody: function(out) {
                                                  out.t("Help us spread Multipple");
                                                }
                                              }, out, __component, "22");

                                            out.ee();

                                            out.ee();

                                            WSAdapt_tag({
                                                hs: "col-4",
                                                class: "col-4 text-right",
                                                renderBody: function(out) {
                                                  out.n(marko_node1, component);
                                                }
                                              }, out, __component, "23");
                                          }
                                        }, out, __component, "19");

                                      out.ee();

                                      out.be("div", marko_attrs10, "25", component);

                                      out.be("p", marko_attrs11, "26", component);

                                      Locale_tag({
                                          renderBody: function(out) {
                                            out.t("Share with people around you ...");
                                          }
                                        }, out, __component, "27");

                                      out.ee();

                                      out.ee();

                                      out.ee();
                                    }
                                  },
                                {
                                    ns: "col-md-4 col-12",
                                    qs: "col-md-4 col-12",
                                    hs: "d-md-none d-block col-12",
                                    class: "px-50",
                                    renderBody: function(out) {
                                      out.be("a", marko_attrs14, "29", component);

                                      out.be("div", marko_attrs15, "30", component);

                                      Row_tag({
                                          class: "card-header p-0",
                                          renderBody: function(out) {
                                            out.be("div", marko_attrs18, "32", component);

                                            out.be("h5", marko_attrs19, "33", component);

                                            Locale_tag({
                                                renderBody: function(out) {
                                                  out.t("Join our Devs Community");
                                                }
                                              }, out, __component, "34");

                                            out.ee();

                                            out.ee();

                                            WSAdapt_tag({
                                                hs: "col-4",
                                                class: "col-4 text-right",
                                                renderBody: function(out) {
                                                  out.n(marko_node2, component);
                                                }
                                              }, out, __component, "35");
                                          }
                                        }, out, __component, "31");

                                      out.ee();

                                      out.be("div", marko_attrs16, "37", component);

                                      out.be("p", marko_attrs17, "38", component);

                                      Locale_tag({
                                          renderBody: function(out) {
                                            out.t("We have a very active community ...");
                                          }
                                        }, out, __component, "39");

                                      out.ee();

                                      out.ee();

                                      out.ee();
                                    }
                                  }
                              ]
                          }, out, __component, "3");
                      }
                    },
                  {
                      ns: "col-lg-3 col-12",
                      qs: "col-lg-4 col-12",
                      hs: "col-lg-5 col-12",
                      class: "position-relative pl-2 pt-50",
                      renderBody: function(out) {
                        out.be("h5", marko_attrs20, "41", component);

                        Locale_tag({
                            renderBody: function(out) {
                              out.t("Contact Support");
                            }
                          }, out, __component, "42");

                        out.ee();

                        out.be("p", marko_attrs21, "43", component);

                        Locale_tag({
                            renderBody: function(out) {
                              out.t("For any assistance, check out documentations, community feedbacks or get in touch with us. We'll be happy to help.");
                            }
                          }, out, __component, "44");

                        out.ee();
                      }
                    }
                ]
            }, out, __component, "1");

          out.be("span", marko_attrs1, "45", component, null, 0, {
              onclick: __component.d("click", "onExpand", false, [
                  false
                ])
            });

          Bx_tag({
              type: "chevron-down",
              class: "float-left font-large-1"
            }, out, __component, "46");

          out.ee();
        } else {
          Row_tag({
              class: "m-0 d-flex align-items-center",
              renderBody: function(out) {
                Row_tag({
                    class: "col d-md-block d-none pb-25",
                    renderBody: function(out) {
                      if (state.activities && state.activities.length) {
                        var $for$0 = 0;

                        marko_forOf(state.activities, function({ title, path }, index) {
                          var $keyScope$0 = "[" + (($for$0++) + "]");

                          WSAdapt_tag({
                              qs: "col-3",
                              hs: "col-4",
                              class: "col-2 px-50 py-0",
                              renderBody: function(out) {
                                route_link_tag({
                                    href: path,
                                    class: "display-block theme-bg cursor-pointer p-50 font-small-2 text-center text-ellipsis",
                                    renderBody: function(out) {
                                      Locale_tag({
                                          text: title
                                        }, out, __component, "51" + $keyScope$0);
                                    }
                                  }, out, __component, "50" + $keyScope$0);
                              }
                            }, out, __component, "49" + $keyScope$0);
                        });
                      }
                    }
                  }, out, __component, "48");

                out.be("div", marko_attrs22, "52", component);

                out.be("ul", marko_attrs23, "53", component);

                out.be("li", marko_attrs24, "54", component, null, 0, {
                    onclick: __component.d("click", () => component.emit('feedback'), false)
                  });

                Locale_tag({
                    text: "Feedbacks",
                    style: "padding-left:8px"
                  }, out, __component, "55");

                out.ee();

                out.be("li", marko_attrs25, "56", component, null, 0, {
                    onclick: __component.d("click", () => component.emit('help'), false)
                  });

                Locale_tag({
                    text: "Help",
                    style: "padding-left:8px"
                  }, out, __component, "57");

                out.ee();

                out.be("li", marko_attrs26, "58", component, null, 0, {
                    onclick: __component.d("click", "onExpand", false, [
                        true
                      ])
                  });

                Bx_tag({
                    type: "chevron-up",
                    class: "float-left font-medium-5"
                  }, out, __component, "59");

                out.ee();

                out.ee();

                out.ee();
              }
            }, out, __component, "47");
        }

        out.ee();
      }
    }, out, __component, "60");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
